// extracted by mini-css-extract-plugin
export default {"header":"style_header__1r9Nx","title":"style_title__Aeqpn","close":"style_close__-sdsk"};